$(document).ready(function() {

    /* OPEN VARIATION BY URL PARAMS */
    if(typeof VARIABLE_ATTR != 'undefined'){
        const queryString = window.location.search;
        if(queryString){
            const urlParams = new URLSearchParams(queryString);
            jQuery.each(VARIABLE_ATTR, function(index, item) {
                let param_value = urlParams.get('attribute_'+item);
                let select = $('.js-variation-select[name="attribute_'+ item +'"]');
                if(select.length){
                    select.val(param_value);
                }
            })
        }
    }

    /* color picker variable product */
    $('.color-changer-wrapper .js-change-color').click(function () {
        $('.color-changer-wrapper .js-change-color.active').removeClass('active');
        $(this).addClass('active');
        let value = $(this).data('value');
        $('#color_picker').val(value).trigger('change');
    });

    /* make color active on select from select box */
    $('.single_variation_wrap').on('show_variation', function (event, variation) {
        const color_select = $('#color_picker');
        if(color_select.length){
            $('.product-detail__main-img').wc_set_variation_attr('src', variation.image.src);
            let value = color_select.val();
            $('.color-changer-wrapper .js-change-color.active').removeClass('active');
            $('.color-changer-wrapper .js-change-color[data-value="' + value + '"]').addClass('active');
        }
    });

    let variation_selects = $('#variations-selects select');
    if(variation_selects.length) {
        /* change url on variation select */
        /*
        variation_selects.change(function () {
            let getParameters = '';
            variation_selects.each(function () {
                let value = $(this).val();
                if (value) {
                    let attr_name = $(this).data('attribute_name');
                    if (getParameters == '') {
                        getParameters = '?' + attr_name + '=' + value;
                    } else {
                        getParameters += '&' + attr_name + '=' + value;
                    }
                }
            })
            window.history.replaceState({}, '', getParameters);
        });
        */

        // vyberie 2. možnosť (prvá možnosť je default value="" a potom product_variation.js
        // odstráni default možnosť

        setTimeout(select_variation_option, 200, variation_selects)
    }

    // unselect color theme select nothing from select box
    $( '.variations_form' ).on( 'woocommerce_variation_select_change', function () {
        let value = $('#color_picker').val();
        if(!value){
            $('.color-changer-wrapper .js-change-color.active').removeClass('active');
        }
    } );

    $('.js-enlarge-image').click(function(){
        let key = $(this).attr('data-key');
        let src = $(this).attr('data-full-src');
        if(!src){
            src = $(this).attr('data-src');
        }
        $('.js-large-image').attr('data-open-key', key);

        $('.js-large-image img').fadeOut(100, function(){
            $(this).attr('src', src);
            $(this).fadeIn(100);
        })
        $('.product-detail__thumbnails .active').removeClass('active');
        $(this).addClass('active');
    });

    $('.js-load-cross-sells').click(function(){
        if($(this).data('initialized') !== 1){
            $(this).attr('data-initialized', 1);
            $.ajax( {
                type:     'POST',
                url:      BASE_URL+'/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                    'action': 'woo_get_product_cross_sells',
                    'product_id': $(this).data('product-id'),
                },
                success:  function( response ) {
                    $('#tab-cross-sells').html(response);
                    if (lazyLoadInstance) {
                        lazyLoadInstance.update();
                    }
                }
            });
        }
    })

    $('.js-product-tabs-nav li').click(function(){
        scrollTo( $('.js-product-tabs-content'), false, 250, 400 );
    })

    /*
    // vytlacenie produktovej page
    $('.js-print').click(function(){
        var elem = $(this).html();
        $('.js-print').html('<img class="loader" src="'+LOADER+'" alt="ajax loader">');
        var tab = $(this).attr('data-tab');
        $('.tabs-nav li[data-tab="'+tab+'"').click()
        $('head').append('<link rel="stylesheet" href="'+ THEME_DIR +'/assets/css/print/product_detail_print.css" media="print" />');
        setTimeout(function() {
            window.print();
            $('.js-print').html(elem);
        }, 1000);
    })

    $('.js-copy').click(function(){
        var text = $(this).attr('data-copy');
        const el = document.createElement('textarea');
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        var text_success = $(this).data('success_text');
        notif('success', text_success);
    })

    // odporucenie produktu
    $('.js-recommend-item-form').submit(function(e){
        e.preventDefault();
        var url = window.location.href;
        var text_success = $('.success_message' ,this).val();
        var text_fail = $('.fail_message' ,this).val();

        $('.form-control', this).val('');
        modal_close();
        notif('success', text_success);

        $.post(url, $(this).serialize() + '&_wp_http_referer=' + url, function (result){
        });
    })
    */
})

function remove_redundant_color_circles(){
    $('#color_picker option').each(function(){
        $('.change-color-circle[data-value="'+ $(this).val() +'"]').addClass('available');
    })
    $('.js-change-color:not(.available)').remove();
}

function select_variation_option(variation_selects){
    variation_selects.each(function () {
        if ($(this).data('show_option_none') === 'no' && !$(this).val() ) {
            $(this).prop('selectedIndex', 1);
            $(this).change();
        }
    })
}
